import script from "./LoaderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderCard.vue?vue&type=script&setup=true&lang=js"

import "./LoaderCard.vue?vue&type=style&index=0&id=24641fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24641fa8"]])

export default __exports__